/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DividendPaymentNotificationPayloadDto
 */
export interface DividendPaymentNotificationPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationPayloadDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationPayloadDto
     */
    symbolId: string;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationPayloadDto
     */
    symbolName: string;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationPayloadDto
     */
    symbolCode: string;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationPayloadDto
     */
    exchangeId: string;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationPayloadDto
     */
    paymentDate: string;
    /**
     * 
     * @type {number}
     * @memberof DividendPaymentNotificationPayloadDto
     */
    grossAmount: number;
}

export function DividendPaymentNotificationPayloadDtoFromJSON(json: any): DividendPaymentNotificationPayloadDto {
    return DividendPaymentNotificationPayloadDtoFromJSONTyped(json, false);
}

export function DividendPaymentNotificationPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DividendPaymentNotificationPayloadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'symbolId': json['symbolId'],
        'symbolName': json['symbolName'],
        'symbolCode': json['symbolCode'],
        'exchangeId': json['exchangeId'],
        'paymentDate': json['paymentDate'],
        'grossAmount': json['grossAmount'],
    };
}

export function DividendPaymentNotificationPayloadDtoToJSON(value?: DividendPaymentNotificationPayloadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currencyCode': value.currencyCode,
        'symbolId': value.symbolId,
        'symbolName': value.symbolName,
        'symbolCode': value.symbolCode,
        'exchangeId': value.exchangeId,
        'paymentDate': value.paymentDate,
        'grossAmount': value.grossAmount,
    };
}

